import { _ as _typeof } from '../typeof-D-UKOauR.js';
import IS_BROWSER from '../isBrowser/index.js';
import operatingSystemEnum from '../operatingSystemEnum/index.js';

var getMobileOperatingSystem = function getMobileOperatingSystem(os) {
  if (os) {
    return os;
  }
  if (!IS_BROWSER || (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object' || !window.navigator) {
    return undefined;
  }
  var userAgent = navigator.userAgent || navigator.vendor;
  if (/windows phone/i.test(userAgent)) {
    return operatingSystemEnum.WindowsPhone;
  }
  if (/android/i.test(userAgent)) {
    return operatingSystemEnum.Android;
  }
  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return operatingSystemEnum.IOS;
  }
  return undefined;
};

export { getMobileOperatingSystem as default };
//# sourceMappingURL=index.js.map
